import { render, staticRenderFns } from "./vehicle-header-view.vue?vue&type=template&id=33d53b32&scoped=true&"
import script from "./vehicle-header-view.vue?vue&type=script&lang=js&"
export * from "./vehicle-header-view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d53b32",
  null
  
)

export default component.exports